import React, { useEffect, useState } from 'react';
import SEO from '../seo/SEO';
import styled from 'styled-components';
import { useLanguage } from '../contexts/LanguageContext';

const Page = styled.section`
  padding: 150px 0 0;
  background: #ffffff;
`;

const Wrap = styled.div`
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  padding: 40px 60px;
  @media (max-width: 968px) {
    padding: 0 40px;
  }
`;

const Title = styled.h1`
  font-family: 'Tiro Bangla', serif;
  font-size: clamp(28px, 5vw, 42px);
  letter-spacing: 2px;
  text-transform: uppercase;
  color: #67313a;
  margin: 0 0 12px;
`;

const Lead = styled.p`
  font-family: 'Montserrat', sans-serif;
  font-size: 12px;
  letter-spacing: 3px;
  text-transform: uppercase;
  color: #a89b97;
  margin: 0 0 20px;
`;

const HeaderBlock = styled.div`
  text-align: center;
  margin-bottom: 8px;
`;

const Canvas = styled.div`
  background: #fbf7f2;
  padding: 60px 0 90px;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: start;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    gap: 34px;
  }
`;

const Grid2 = styled(Grid)`
  margin-top: 70px;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  @media (max-width: 1024px) {
    justify-items: center;
    & > *:nth-child(1) { order: 2; } /* put text after image */
    & > *:nth-child(2) { order: 1; } /* image first */
    & > div { width: 100%; }
  }
`;

const RightTitle = styled.h2`
  font-family: 'Tiro Bangla', serif;
  font-size: clamp(22px, 4.2vw, 28px);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 2.2px;
  color: #67313a;
  margin: 0 0 14px;
`;

const Bio = styled.p`
  font-family: 'Barlow Semi Condensed', sans-serif;
  font-size: 16px;
  line-height: 1.9;
  color: #5f5a57;
  margin-bottom: 14px;
`;

const SectionTitle = styled.h3`
  font-family: 'Tiro Bangla', serif;
  font-size: clamp(22px, 4.2vw, 28px);
  text-transform: uppercase;
  letter-spacing: 2.2px;
  color: #67313a;
  margin: 0 0 12px;
`;

const BigImage = styled.img`
  width: 100%;
  height: auto;
  display: block;
  box-shadow: 0 16px 36px rgba(0,0,0,0.08);
`;

const PhotoTile = styled.div`
  background: #0b0b0b;
  padding: 18px;
  width: 420px;
  max-width: 100%;
  justify-self: end;
  box-shadow: 0 18px 40px rgba(0,0,0,0.18);

  @media (max-width: 1024px) {
    justify-self: start;
    width: 100%;
  }
`;

const RightPhoto = styled.img`
  width: 100%;
  height: auto;
  display: block;
`;

 
// Marble banner with centered monogram
const MarbleBanner = styled.section`
  background: url('/images/Marbre 1 - 1500px.webp') center/cover no-repeat;
  padding: 80px 0;
  text-align: center;
`;

const Monogram = styled.img`
  width: 56px;
  height: auto;
  filter: drop-shadow(0 10px 24px rgba(0,0,0,0.25));
`;

const BannerTitle = styled.h2`
  margin: 12px 0 0;
  font-family: 'Tiro Bangla', serif;
  font-size: clamp(18px, 4.8vw, 28px);
  letter-spacing: 2px;
  text-transform: uppercase;
  color: #ffffff;
  font-weight: 400;
`;

// Testimonials section
const TestiSection = styled.section`
  background: #ffffff;
  padding: 80px 0 100px;
`;

const TGrid = styled.div`
  display: grid;
  grid-template-columns: 1.2fr 1fr;
  gap: 60px;
  align-items: center;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    gap: 34px;
  }
`;

const Quote = styled.blockquote`
  margin: 0;
  font-family: 'Barlow Semi Condensed', sans-serif;
  font-size: 18px;
  line-height: 2.0;
  color: #5f5a57;
`;

const Author = styled.div`
  margin-top: 12px;
  font-family: 'Montserrat', sans-serif;
  letter-spacing: 2px;
  text-transform: uppercase;
  font-size: 12px;
  color: #a89b97;
`;

const TDots = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 16px;
`;

const TDot = styled.button`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  border: 0;
  background: ${({ active }) => (active ? '#67313a' : '#d7cfcb')};
  cursor: pointer;
`;

const CarRow = styled.div`
  display: grid;
  grid-template-columns: 40px 1fr 40px;
  align-items: center;
  gap: 20px;
`;

const ArrowBtn = styled.button`
  background: none;
  border: none;
  color: #2a2a2a;
  font-size: 32px;
  line-height: 1;
  cursor: pointer;
  padding: 6px 4px;
  transition: transform 0.2s ease;
  &:hover { transform: scale(1.08); }
`;

const TestiImg = styled.img`
  width: 380px;
  max-width: 100%;
  height: auto;
  display: block;
  margin: 0 auto;
  box-shadow: 0 16px 36px rgba(0,0,0,0.08);
`;

const TestiName = styled.h3`
  font-family: 'Tiro Bangla', serif;
  font-size: clamp(20px, 4.2vw, 26px);
  text-transform: uppercase;
  letter-spacing: 2px;
  color: #8f8a88;
  margin: 0 0 14px;
`;

const AboutPage = () => {
  const { lang } = useLanguage();
  const SLIDES = [
    {
      author: 'Soline & Julien',
      img: '/images/Soline & Julien - Lino ludovic - 19.webp',
      quoteFr:
        "Nos photos de mariage sont sublimes ! On a reçu que des compliments de la part de nos invités. Ludo a su nous mettre à l'aise devant l'objectif et nous a fait vivre des moments inoubliables durant les séances photos. Je recommande les yeux fermés.",
      quoteEn:
        "Our wedding photos are sublime! We received nothing but compliments from our guests. Ludo made us feel comfortable in front of the camera and gave us unforgettable moments during the photo sessions. We recommend him wholeheartedly.",
    },
    {
      author: 'Claire & Quentin',
      img: '/images/Claire_Quentin/Claire and quentin - wedding photographer France Provence (26).webp',
      quoteFr:
        "On recommande à 100% autant pour la qualité des photos de Ludovic que pour sa personne. Un suivi tout au long de la préparation du mariage, des conseils très avisés, plus qu’un photographe, une vraie valeur ajoutée pour un mariage !",
      quoteEn:
        "We recommend him 100% — both for the quality of Ludovic’s photos and for who he is. He supported us throughout the wedding preparations with thoughtful advice — more than a photographer, a true added value to a wedding!",
    },
    {
      author: 'Adélie & Julien',
      img: '/images/Adélie_et_Julien/00563- Adelie & Julien - MD.webp',
      quoteFr:
        "Ludovic nous a accompagné pour notre mariage. Les photos sont splendides et tous nos convives ont adoré Ludovic pour son professionnalisme et sa gentillesse. Nous recommandons vivement ce photographe talentueux.",
      quoteEn:
        "Ludovic accompanied us for our wedding. The photos are splendid, and all our guests loved him for his professionalism and kindness. We highly recommend this talented photographer.",
    },
  ];

  const [tIndex, setTIndex] = useState(0);

  useEffect(() => {
    const id = setInterval(() => {
      setTIndex((i) => (i + 1) % SLIDES.length);
    }, 6000);
    return () => clearInterval(id);
  }, [SLIDES.length]);

  const handlePrev = () => setTIndex((i) => (i - 1 + SLIDES.length) % SLIDES.length);
  const handleNext = () => setTIndex((i) => (i + 1) % SLIDES.length);

  return (
    <Page>
      <SEO
        title={lang === 'fr' ? 'À propos — Lino Ludovic' : 'About — Lino Ludovic'}
        description={
          lang === 'fr'
            ? "Rencontrez l’artiste : sensibilité, élégance éditoriale et approche discrète pour des images intemporelles."
            : 'Meet the artist: sensitivity, editorial elegance, and a discreet approach for timeless imagery.'
        }
        image="/images/Ludovic Lino - Wedding Photographer - France and Worldwide.jpg"
        schema={{
          '@context': 'https://schema.org',
          '@type': 'AboutPage',
          name: lang === 'fr' ? 'À propos' : 'About'
        }}
      />
      <HeaderBlock>
        <Wrap>
          <Title>{lang === 'fr' ? "RENCONTREZ L'ARTISTE" : 'MEET THE ARTIST'}</Title>
          <Lead>{lang === 'fr' ? "DERRIÈRE L’EXPÉRIENCE" : 'BEHIND THE EXPERIENCE'}</Lead>
        </Wrap>
      </HeaderBlock>

      <Canvas>
        <Wrap>
          <Grid>
            <div>
              <BigImage
                src="/images/Ludovic Lino - Wedding Photographer - France and Worldwide.webp"
                alt="Ludovic Lino — Destination Wedding photographer"
                loading="lazy"
              />
            </div>
            <div>
              <RightTitle>
                {lang === 'fr' ? (
                  <>
                    Lino Ludovic,<br /> Sculpteur de lumière
                  </>
                ) : (
                  <>
                    Lino Ludovic,<br /> Light Crafter
                  </>
                )}
              </RightTitle>
              <Bio>
                {lang === 'fr'
                  ? "Depuis plus de dix ans, la photographie de mariage est ma manière de raconter ce que les mots ne peuvent contenir."
                  : 'For over a decade, wedding photography has been my way of telling stories that words cannot hold.'}
              </Bio>
              <Bio>
                {lang === 'fr'
                  ? "Basé entre Rhône-Alpes et Provence, je puise mon inspiration dans la lumière douce, les paysages intemporels et la rare beauté des émotions authentique"
                  : 'Based between Rhône-Alpes and Provence, I am inspired by soft light, timeless landscapes, and the rare beauty of genuine emotions.'}
              </Bio>
              <Bio>
                {lang === 'fr'
                  ? "Ce qui définit mon travail, c’est une sensibilité aiguë, une profonde empathie qui me permet de ressentir pleinement les émotions vécues par mes couples. Cette résonance m’aide à saisir avec précision ce qui se voit rarement : un regard qui passe, la vibration subtile d’un instant, l’essence d’un lien."
                  : 'What defines my work is a heightened sensitivity, a deep empathy that allows me to truly feel the emotions my couples are experiencing. This resonance enables me to capture with precision what often remains unseen: a fleeting glance, the subtle vibration of a moment, the essence of a bond.'}
              </Bio>
              <Bio>
                {lang === 'fr'
                  ? "Ma présence est calme et discrète, instaurant une confiance qui vous permet de vivre pleinement l’instant. Dans cette liberté naissent des images lumineuses, raffinées et profondément personnelles."
                  : 'My presence is calm and discreet, creating a sense of trust that allows you to live fully in the moment. Within that freedom, images arise that are luminous, refined, and profoundly personal.'}
              </Bio>
              <Bio>
                {lang === 'fr'
                  ? "Pour moi, la photographie dépasse l’esthétique. Il s’agit de créer une expérience élégante et fluide, pensée avec soin dans chaque détail, afin que vos souvenirs demeurent comme des héritages intemporels, porteurs d’émotion et d’art."
                  : 'To me, photography goes beyond aesthetics. It is about crafting an elegant and seamless experience, designed with care in every detail, so that your memories endure as timeless heirlooms, reflecting both emotion and artistry.'}
              </Bio>
            </div>
          </Grid>

          <Grid2>
            <div>
              <SectionTitle>{lang === 'fr' ? 'Inspiration & Essence' : 'Inspiration & Essence'}</SectionTitle>
              <Bio>
                {lang === 'fr' ? (
                  <>
                    J’apprécie les luxes discrets de la vie. Le silence d’un coucher de soleil, la lumière dorée sur la Provence ou la Toscane, une conversation profonde ou les rires des instants partagés en famille. La musique m’accompagne toujours, tout comme les belles tables qui célèbrent l’art de vivre.
                    <br />
                    Curieux par nature, je suis attiré par la psychologie, la nature et les voyages, toujours en quête de comprendre, de ressentir et de capturer la beauté sous toutes ses formes. Ces passions nourrissent mon travail et donnent profondeur et authenticité à chaque image que je crée.
                  </>
                ) : (
                  'I cherish life’s quieter luxuries. The silence of a sunset, the golden light over Provence or Tuscany, a meaningful conversation, or the laughter of family moments. Music is a constant companion, as are fine restaurants that celebrate the art of living. I am endlessly curious, drawn to psychology, nature, and travel, always seeking to understand, to feel, and to capture beauty in all its forms. These passions nourish my work, giving depth and authenticity to every image I create.'
                )}
              </Bio>
            </div>
            <PhotoTile>
              <RightPhoto
                src="/images/Ludovic Lino - Wedding photographer .webp"
                alt="Ludovic Lino — Wedding photographer"
                loading="lazy"
              />
            </PhotoTile>
          </Grid2>
        </Wrap>
      </Canvas>

      {/* Marble banner with monogram */}
      <MarbleBanner>
        <Wrap>
          <Monogram src="/images/Monogramme LL2 Blanc.webp" alt="Monogramme LL" loading="lazy" />
          <BannerTitle>{lang === 'fr' ? 'Mots du cœur' : 'Words from the heart'}</BannerTitle>
        </Wrap>
      </MarbleBanner>

      {/* Testimonials carousel */}
      <TestiSection>
        <Wrap>
          <CarRow>
            <ArrowBtn onClick={handlePrev} aria-label="Previous">‹</ArrowBtn>
            <TGrid>
              <div>
                <TestiImg
                  src={SLIDES[tIndex].img}
                  alt={SLIDES[tIndex].author}
                  loading="lazy"
                />
              </div>
              <div>
                <TestiName>{SLIDES[tIndex].author}</TestiName>
                <Quote>{lang === 'fr' ? SLIDES[tIndex].quoteFr : SLIDES[tIndex].quoteEn}</Quote>
                <TDots>
                  {SLIDES.map((_, i) => (
                    <TDot key={i} active={i === tIndex} onClick={() => setTIndex(i)} aria-label={`Go to testimonial ${i + 1}`} />
                  ))}
                </TDots>
              </div>
            </TGrid>
            <ArrowBtn onClick={handleNext} aria-label="Next">›</ArrowBtn>
          </CarRow>
        </Wrap>
      </TestiSection>
    </Page>
  );
};

export default AboutPage;
